import React from 'react';
import { ApolloProvider } from '@apollo/client';
import { IntlProvider } from 'react-intl';
import client from '../../lib/apolloClient';
import getMessages from '../../lib/i18n/getMessages';
import { CurrencyProvider } from '../../hooks/useCurrency';
import SuccessionListSearch from '../../components/Succession/Search/SuccessionListSearch';

/**
 * Container component for SuccessionMapSearch
 * This container actually reuses the SuccessionListSearch component, which now handles both views.
 * It auto-selects the map view when rendered.
 */
const SuccessionMapSearchContainer = (props, railsContext) => {
  // We're reusing the SuccessionListSearch component which has both views
  // Just passing initialViewMode='map' to set the initial view
  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  window.currency = (railsContext && railsContext.currency) || window.currency || 'USD';
  const locale = window.locale;
  return (
    <CurrencyProvider currency={(railsContext && railsContext.currency) || window.currency || 'USD'}>
      <ApolloProvider client={client}>
        <IntlProvider locale={locale} messages={getMessages(locale)}>
          <SuccessionListSearch
            {...props}
            initialViewMode='map'
          />
        </IntlProvider>
      </ApolloProvider>
    </CurrencyProvider>
  );
};

export default SuccessionMapSearchContainer; 